import deValidateMessages from "vee-validate/dist/locale/de.json"
import esValidateMessages from "vee-validate/dist/locale/es.json"
import nlValidateMessages from "vee-validate/dist/locale/nl.json"

import de from "./de"
import ch from "./ch"
import at from "./at"
import nl from "./nl"
import es from "./es"
import deSections from "./sections.de"
import chSections from "./sections.ch"
import atSections from "./sections.at"
import nlSections from "./sections.nl"
import esSections from "./sections.es"

const messages = {
  de: {
    ...de,
    ...deSections,
    "zip-code-input": "PLZ",
    validation: { ...deValidateMessages.messages }
  },
  ch: {
    ...ch,
    ...chSections,
    "zip-code-input": "PLZ",
    validation: deValidateMessages.messages
  },
  at: {
    ...at,
    ...atSections,
    "zip-code-input": "PLZ",
    validation: deValidateMessages.messages
  },
  es: {
    ...es,
    ...esSections,
    "zip-code-input": "Código postal",
    validation: esValidateMessages.messages
  },
  nl: {
    ...nl,
    ...nlSections,
    "zip-code-input": "Postcode",
    validation: nlValidateMessages.messages
  }
}

export default messages
